<template>
  <div>
    <div>
      <hm-step
        :steps="steps"
        :step="step"
        :disabledFirst="disabledFirst"
        disabledNext
      ></hm-step>
    </div>
    <hm-content title="">
      <template v-if="step === 1">
        <div class="cnm text-center">
          <img
            src="https://imgcdn.hemiao100.com/ThemePictures/wc3.png"
            alt=""
            class="top_img"
          />
        </div>
        <div class="text-center hehe">
          接入企业微信-体验企业服务新方式
        </div>
        <div class="text-center gnn">
          <img
            src="https://imgcdn.hemiao100.com/ThemePictures/dawdwadwa.png"
            alt=""
          />
        </div>
        <div class="flex flex-center">
          <div class="next_btn pointer" @click="goo">
            查看企业微信安装「禾店掌」教程
          </div>
        </div>
        <div
          style="color: #999;padding:12px;font-size: 18px;"
          class="text-center"
        >
          或
        </div>
        <div class="flex flex-center">
          <div
            class="next_btns pointer flex item-center flex-center"
            @click="step = 2"
          >
            <img
              class="icon_wc4"
              src="https://imgcdn.hemiao100.com/ThemePictures/wc4.png"
              alt=""
            />
            <span>注册企业微信</span>
          </div>
        </div>
      </template>
      <template v-else-if="step === 2">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <div class="rule-title flex item-center">
            第1步： 登录企业微信后台复制企业id到禾苗
          </div>
          <el-form-item label="企业id" prop="qywxCorpid">
            <el-input
              clearable
              size="small"
              class="mr10 ipt"
              v-model.trim="ruleForm.qywxCorpid"
              placeholder="请输入企业id"
            ></el-input>
          </el-form-item>
          <div>
            <el-image
              src="https://imgcdn.hemiao100.com/ThemePictures/6b40b68e-dfd6-41e2-b7c3-e3df866a4de2__671b91c7c968beeeb4546f195224f486.png"
              fit="fill"
            ></el-image>
          </div>
          <div class="rule-title flex item-center mt20">
            第2步：点击查看Secret，并填入下方输入框中
          </div>
          <el-form-item label="Secret" prop="qywxCorpsecret">
            <el-input
              clearable
              size="small"
              class="mr10 ipt"
              v-model.trim="ruleForm.qywxCorpsecret"
              placeholder="请输入Secret"
            ></el-input>
          </el-form-item>
          <div>
            <el-image
              src="https://imgcdn.hemiao100.com/ThemePictures/6b40b68e-dfd6-41e2-b7c3-e3df866a4de2__098b2273bdbd0fcf22230920a39d9cf1.png"
              fit="fill"
            ></el-image>
          </div>
          <div class="mt20 flex flex-center">
            <el-button
              @click="submitForm('ruleForm')"
              size="small"
              type="primary"
              >下一步</el-button
            >
          </div>
        </el-form>
      </template>
      <template v-else-if="step === 3">
        <div class="flex flex-center" style="margin-top: 70px;">
          <div class="yuan text-center" v-if="type === 'success'">
            <span style="font-size: 30px" class="hmicon icon-duigou"></span>
          </div>
          <span
            v-else
            class="hmicon icon-tishi"
            style="font-size:50px;color:#FF7F10"
          ></span>
        </div>
        <div
          class=" text-center mt10"
          style="font-size: 18px;font-weight: 600;"
          :class="type === 'success' ? 'success' : 'orange'"
        >
          {{
            type === "success"
              ? "安装成功"
              : "验证失败，您的企业微信未安装禾店掌"
          }}
        </div>
        <div class="text-center mt10" style="font-size: 16px;color: #000;">
          {{
            type === "success"
              ? "您的企业微信已经安装成功"
              : "如有疑问请联系客服"
          }}
        </div>
        <div class="flex flex-center mt20" v-if="type === 'success'">
          <el-button @click="backIndex" size="small" type="primary"
            >进入管理</el-button
          >
        </div>
        <div class="flex flex-center mt20" v-else>
          <el-button
            @click="dialogVisibleService = true"
            size="small"
            type="primary"
            plain
            >联系客服</el-button
          >
          <el-button @click="step = 1" size="small" type="primary"
            >重新安装</el-button
          >
        </div>
      </template>
    </hm-content>

    <el-dialog
      :close-on-click-modal="false"
      width="35%"
      :visible.sync="dialogVisible"
    >
      <div slot="title" style="height:18px"></div>
      <div class="flex flex-center">
        <span
          class="hmicon icon-tishi"
          style="font-size:50px;color:#FF7F10"
        ></span>
      </div>
      <div class="text-center mt10" style="font-size:18px;color:#FF7F10">
        温馨提示
      </div>

      <div
        class="text-center mt10"
        style="font-weight: 600;color: #222222;line-height: 22px;"
      >
        请在新窗口里面按教程安装【禾店掌】应用
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="dialogVisible = false" size="small" type="primary"
          >暂不安装</el-button
        >
        <el-button
          size="small"
          @click="
            step = 2;
            dialogVisible = false;
          "
          type="primary"
          plain
          >已完成安装，下一步</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      width="35%"
      :visible.sync="dialogVisibleService"
      title="联系客服"
    >
      <div class="flex flex-center">
        <el-image
          style="width: 400px; height: 400px"
          :src="url"
          :preview-src-list="[url]"
        >
        </el-image>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button
          @click="dialogVisibleService = false"
          size="small"
          type="primary"
          >确认</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import HmStep from "@/components/HmStep";
export default {
  components: {
    HmStep
  },
  data() {
    return {
      url:
        "https://imgcdn.hemiao100.com/ThemePictures/qrcode.png",
      type: "danger",
      dialogVisibleService: false,
      dialogVisible: false,
      step: 1,
      steps: [
        {
          link: "",
          name: "企业微信应用市场安装禾苗"
        },
        {
          link: "",
          name: "复制密钥到禾苗"
        },
        {
          link: "",
          name: "安装完成"
        }
      ],
      disabledFirst: false,
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {},
      ruleForm: {
        qywxCorpid: "",
        qywxCorpsecret: ""
      },
      rules: {
        qywxCorpid: {
          required: true,
          message: "请输入企业id",
          trigger: "blur"
        },
        qywxCorpsecret: {
          required: true,
          message: "请输入Secret",
          trigger: "blur"
        }
      }
    };
  },
  created() {},
  mounted() {},
  methods: {
    backIndex() {
      this.$router.push({
        path: "/wechat/index"
      });
    },
    async submitForm(ruleForm) {
      // try {
      const valid = await this.$refs[ruleForm].validate();
      if (valid) {
        let params = {
          qywxCorpid: this.ruleForm.qywxCorpid,
          qywxCorpsecret: this.ruleForm.qywxCorpsecret
        };
        try {
          await this.$store.dispatch("companyWechatInstall", params);
          this.type = "success";
        } catch (err) {
          this.type = "danger";
        }
        this.step = 3;
      } else {
        setTimeout(() => {
          var isError = document.getElementsByClassName("is-error");
          if (isError[0].querySelector("input")) {
            isError[0].querySelector("input").focus();
          } else if (isError[0].querySelector("textarea")) {
            isError[0].querySelector("textarea").focus();
          }
        }, 1);
        return false;
      }
      // } catch (err) {
      //   console.log("err: ", err);
      // }
    },
    goo() {
      window.open(
        "https://hemiao100.yuque.com/docs/share/9a7723d1-9b98-44ca-a5a1-a036063c00e7?#"
      );
      this.dialogVisible = true;
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.store.dispatch("", params);
      if (code === "0") {
        const { total, records } = result;
        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    }
  }
};
</script>

<style scoped lang="scss">
.cnm {
  margin-top: 50px;
}
.hehe {
  line-height: 28px;
  font-size: 20px;
  color: #999999;
  margin-top: 15px;
}
.gnn {
  margin-top: 35px;
  margin-bottom: 40px;
  img {
    width: 360px;
  }
}
.next_btn {
  width: 360px;
  text-align: center;
  color: #ffffff;
  height: 48px;
  line-height: 48px;
  background: #0081e5;
  border-radius: 4px;
}
.next_btns {
  width: 360px;
  text-align: center;
  color: #0081e5;
  height: 48px;
  // line-height: 48px;
  background: ffffff;
  border-radius: 4px;
  border: 1px solid #0081e5;
}

.rule-title {
  font-size: 16px;
  margin-bottom: 10px;
  color: rgba(34, 34, 34, 1);
  font-weight: bold;
  &::before {
    content: "";
    width: 4px;
    display: inline-block;
    margin-right: 8px;
    height: 12px;
    background: #e50065;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
}
.yuan {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #2fc348;
  .icon-duigou {
    line-height: 56px;
    text-align: center;
    color: #fff;
  }
}
</style>
